export const en = {
    activeGame: {
        activeSession: 'Active Session',
        askAdministrator: 'Ask Administrator to start a game',
        askMarker: 'Ask Marker to start a game',
        askMarkerToClose: 'To close the table, ask a Marker',
        atTheTable: 'At the table',
        bookTable: 'Book a table',
        bookTableComingSoon: 'Booking tables from your account is coming soon. Please ask an administrator to start a game.',
        closeTable: 'Close table',
        editProfile: 'Edit Profile',
        endSet: 'End set',
        hello: 'Hello, {{name}}',
        live: 'Live',
        loading: 'Loading session data...',
        logout: 'Logout',
        pause: 'Pause',
        pauseAccrued: 'Pause (accrued)',
        pauseFull: 'Pause {{minutes}} min',
        pauseAvailable: 'Pause available',
        pauseRemaining: 'Pause remaining',
        lowPauseWarning:
            'Unfortunately, less than 30 seconds of pause remain. Please play a little longer to earn more pause time, or ask a marker if you need a longer break.',
        paused: 'Paused',
        playedTime: 'Played time',
        resume: 'Resume',
        started: 'Started',
        tableFallback: 'Table {{tableId}}',
        multipleGames: 'You have {{count}} active games',
        videoRecording: 'Video recording',
        foulReview: 'Foul review',
        clipEditing: 'Clip editing',
        lateVideoRecording: 'Late video recording',
        callWaiter: 'Call waiter',
    },
    foulReview: {
        title: 'Foul review',
        preparing: 'Preparing latest footage…',
        scrollHint: 'Scrub near the end for what just happened. Drag earlier or tap “Load earlier” for more.',
        loadingEarlier: 'Loading earlier video…',
        loadEarlier: 'Load earlier clip',
        noEarlier: 'No earlier footage in retention',
        close: 'Close',
        addFree: 'Done — included with video',
        addCharge: 'Add foul charge · {{amount}} UAH',
        retry: 'Try again',
        failedOpen: 'Could not open foul review.',
        webOnly: 'Foul review video scrub is available in the web app.',
        playbackError: 'Video playback failed ({{detail}}). Retry after the new video-orchestrator image, or check camera codec.',
        mute: 'Mute',
        unmute: 'Sound',
        jumpLatest: 'Latest',
    },
    userHome: {
        profile: 'Profile',
        // TEMPORARY — remove when user cabinet leaves testing
        testingNotice: 'The user cabinet is in testing. Any issues or suggestions discuss with Marker',
        loyaltyInfoA11y: 'How the loyalty program works',
    },
    gameDiscipline: {
        PYRAMID: 'Pyramid',
        POOL: 'Pool',
        HEYBALL: 'Heyball',
        SNOOKER: 'Snooker',
    },
    gameVariant: {
        FREE: 'Free',
        DYNAMIC: 'Dynamic',
        COMBINATION: 'Combination',
        CLASSIC: 'Classic',
        SAUSAGE: 'Sausage',
        EIGHT_BALL: '8-ball',
        NINE_BALL: '9-ball',
        STRAIGHT: 'Straight pool',
        STANDARD: 'Standard',
    },
    rivalSearch: {
        title: 'Rival search',
        createCta: 'Looking for a rival',
        createTitle: 'Looking for a rival',
        offerTitle: 'Offer to play',
        imInterested: "I'm interested",
        gameLabel: 'Game',
        rulesLabel: 'Rules',
        whenLabel: 'When',
        whenNow: 'Now',
        whenTodayEvening: 'Today evening',
        whenTomorrow: 'Tomorrow',
        whenSpecific: 'Specific time',
        anyRules: 'Any',
        createConsent:
            'Players who express interest will share their contact details with you.',
        offerConsent:
            'By expressing interest, your contact details are shared with the seeker.',
        submit: 'Submit',
        filterAll: 'All',
        emptyBoard: 'No one looking right now — be the first.',
        emptyFiltered: 'No requests for this game.',
        yours: 'Yours',
        createSuccess: 'Rival search request posted.',
        createFailed: 'Failed to post request.',
        disciplineRequired: 'Please select a game.',
        interestFailed: 'Failed to express interest.',
        contactTelegram: 'Telegram',
        contactPhone: 'Phone',
        contactEmail: 'Email',
        requestDetail: 'Your rival request',
        interestedPlayers: 'Interested players',
        noInterestsYet: 'No one has expressed interest yet.',
        continueSearch: 'Continue search',
        rivalFound: 'Rival is found',
        closedSuccess: 'Rival found — request closed.',
        closeFailed: 'Failed to close request.',
        loadFailed: 'Failed to load request.',
        interestCount: '{{count}} interested',
        staffButton: 'Rival search',
    },
    clubContact: {
        instagram: 'Instagram',
        telegram: 'Telegram',
        telegramChat: '(Chat)',
        telegramChatA11y: 'Telegram chat',
        callPhone: 'Call {{phone}}',
    },
    userBooking: {
        orDivider: 'OR',
        modalTitle: 'Book a table',
        tableType: 'Table type',
        tableTypeRequired: 'Please select a table type.',
        noTableTypes: 'No table types are available for booking right now.',
        dateLabel: 'Date',
        dateToday: 'Today',
        dateTomorrow: 'Tomorrow',
        datePick: 'Select a date',
        notes: 'Note',
        notesPlaceholder: 'e.g. I would like table 5, 6 or 7',
        cancel: 'Cancel',
        submit: 'Book a table',
        submitSuccess: 'Booking request sent.',
        submitFailed: 'Failed to send booking request.',
        pendingThanks: 'Thanks for booking. Please wait for confirmation or call {{phone}}.',
        pendingThanksNoPhone: 'Thanks for booking. Please wait for confirmation.',
        confirmedWaiting: '{{tableName}} is waiting for you on {{date}} at {{time}}',
        bookedTable: 'Booked table',
    },
    notifications: {
        addPlayerComingSoon: 'Add player functionality coming soon!',
        addPlayerBeforeFinishing: 'Add at least one player before finishing the set.',
        addPlayerBeforeStopping: 'Add at least one player before stopping the table.',
        addPlayerFailed: 'Failed to add player.',
        playerAdded: 'Player added to the session.',
        playerMarkedLeft: 'Player marked as left.',
        markPlayerLeftFailed: 'Failed to mark player as left.',
        failedFinishSet: 'Failed to finish set: {{message}}',
        failedLoadSetSummary: 'Failed to load set summary: {{message}}',
        failedPauseTable: 'Failed to pause table: {{message}}',
        failedResumeTable: 'Failed to resume table: {{message}}',
        failedStopTable: 'Failed to stop table: {{message}}',
        selectedUser: 'Selected user: {{name}}',
        setFinished: 'Set finished successfully.',
        tablePaused: '{{tableName}} paused successfully',
        tableResumed: '{{tableName}} resumed successfully',
        tableStopped: 'Table stopped successfully.',
        videoRecordingEnabled: 'Video recording billing enabled.',
        videoRecordingDisabled: 'Video recording billing disabled.',
        foulReviewCharged: 'Foul review charge added to the bill.',
        foulReviewFree: 'Foul review noted — included with video recording.',
        clipEditingCharged: 'Clip editing charge added to the bill.',
        failedVideoRecordingToggle: 'Failed to toggle video recording: {{message}}',
        failedVideoCharge: 'Failed to add video charge: {{message}}',
        failedFoulReview: 'Failed to complete foul review: {{message}}',
        waiterCalled: 'Waiter called for {{tableName}}',
        failedCallWaiter: 'Failed to call waiter: {{message}}',
    },
    playerSelection: {
        finishSet: 'Finish Set',
        finishSetMessage: 'Select players who will pay for this set. At least one must be selected.',
        stopTable: 'Stop Table',
        stopTableMessage: 'Select players who will pay for the remaining time. At least one must be selected.',
        specialPayerWarning:
            'Warning: only {{player}} ({{kind}}) is selected as payer while several players are at the table. The whole set will be billed at their special tariff.',
        cancel: 'Cancel',
        confirm: 'Confirm',
    },
    startTable: {
        addPlayerRequired: 'Please add at least one player',
        failedStart: 'Failed to start table',
        selectDuration: 'Please select a duration',
        pauseAfterDuration: 'Pause after duration',
        withTrainer: 'With trainer',
        videoRecording: 'Video recording',
        startSession: 'Start Session',
        durationOptional: 'Duration (Optional)',
        customMinutes: 'Custom (minutes)',
        enterMinutes: 'Enter minutes',
        selectedDuration: 'Selected: {{minutes}} minutes',
        typePlayerName: 'Type player name...',
        addPlayer: 'Add Player',
        presets: {
            min30: '30 min',
            hour1: '1 hour',
            hour1_30: '1h 30m',
            hours2: '2 hours',
            hours2_30: '2h 30m',
            hours3: '3 hours',
        },
    },
    bookings: {
        upcomingTitle: 'Upcoming bookings:',
        noUpcoming: 'No bookings',
    },
    tableDetail: {
        tableType: 'Table Type',
        status: 'Status',
        tableId: 'Table ID',
        technicalInfo: 'Technical Info',
        lastHeartbeat: 'Last Heartbeat',
        missedHeartbeats: 'Missed Heartbeats',
        notAvailable: 'N/A',
        startTable: 'Start Table',
    },
    tariff: {
        current: 'Current',
        training: 'Training',
        maintenance: 'Maintenance',
        sessionTariff: 'Session tariff',
        tariffName: 'Tariff Name',
        pricePerHour: 'Price per Hour',
        activeHours: 'Active Hours',
        currentTariff: 'Current Tariff',
        selectTariff: 'Select tariff',
    },
    players: {
        addPlayer: 'Add Player',
        assigned: 'Assigned',
        guest: 'Guest',
        left: 'Left',
        markLeft: 'Mark left',
        placeholder: 'Search or enter name...',
        players: 'Players',
        tariffFallback: 'Tariff',
    },
    time: {
        minutesShort: 'min',
        ongoing: 'ongoing',
    },
    reports: {
        title: 'Reports',
        loading: 'Loading report...',
        group: {
            takings: 'Takings and usage',
            insights: 'Insights',
            audit: 'Audit log',
        },
        report: {
            money: 'Money',
            tableActivity: 'Table activity',
            militaryTariffs: 'Military tariffs',
            tariffUsage: 'Tariff usage',
            billsList: 'Bills list',
            peakHours: 'Peak hours',
            tableOccupancy: 'Table occupancy rate',
            topSpenders: 'Top spenders',
            loyaltyHealth: 'Loyalty program health',
            tableActions: 'Table actions',
            bonusActions: 'Bonus actions',
            userChanges: 'User changes',
            billPayments: 'Bill payments',
            writeOffs: 'Write-offs',
        },
        ui: {
            report: 'Report',
            month: 'Month',
            year: 'Year',
            custom: 'Custom',
            from: 'From',
            to: 'To',
            prevMonth: 'Previous month',
            nextMonth: 'Next month',
            prevYear: 'Previous year',
            nextYear: 'Next year',
            rangeInvalid: 'From date is after To date',
            tables: 'Tables',
            all: 'All',
            none: 'None',
            nOfN: '{{on}} of {{total}}',
            noTablesSelected: 'Select at least one table',
            exportCsv: 'Export CSV',
            exporting: 'Exporting...',
            exported: 'CSV exported',
            total: 'Total',
            rows: 'Rows',
            user: 'User',
            allUsers: 'All users',
            clearUser: 'Clear user filter',
            noUsersMatch: 'No users match',
            peak: 'Peak',
            peakHour: 'Peak hour',
            promoHeavy: 'Promo-heavy',
            filters: 'Filters',
            close: 'Close',
            retry: 'Retry',
            resetFilters: 'Reset filters',
        },
        fields: {
            ROLE: 'Role',
            ENABLED: 'Enabled',
            ACCOUNT: 'Account',
            DELETED: 'Deleted',
            true: 'Yes',
            false: 'No',
        },
        cols: {
            period: 'Period',
            card: 'Card',
            cash: 'Cash',
            income: 'Income',
            bonuses: 'Bonuses',
            withoutPay: 'Without pay',
            totalSpent: 'Total spent',
            minutes: 'Minutes',
            sessions: 'Sessions',
            revenue: 'Revenue',
            amount: 'Amount',
            sets: 'Sets',
            commercialMinutes: 'Commercial min',
            totalMinutes: 'Total min',
            startTime: 'Start',
            endTime: 'End',
            table: 'Table',
            status: 'Status',
            total: 'Total',
            hour: 'Hour',
            share: 'Share',
            demand: 'Demand',
            availableHours: 'Available hours',
            soldHours: 'Sold hours',
            occupancy: 'Occupancy',
            user: 'User',
            spend: 'Spend',
            promoShare: 'Promo share',
            issued: 'Issued',
            redeemed: 'Redeemed',
            netChange: 'Net change',
            redemptionRate: 'Redemption rate',
            outstanding: 'Outstanding',
            time: 'Time',
            action: 'Action',
            actor: 'Actor',
            adjustedBy: 'Adjusted by',
            balanceAfter: 'Balance after',
            reason: 'Reason',
            changedBy: 'Changed by',
            field: 'Field',
            oldValue: 'Old value',
            newValue: 'New value',
            bill: 'Bill',
            method: 'Method',
            by: 'By',
        },
        tabs: {
            money: 'Money',
            tables: 'Table activity',
            military: 'Military tariffs',
            tariffUsage: 'Tariff usage',
            tableActions: 'Table actions',
            bonuses: 'Bonus changes',
            userChanges: 'User changes',
            billPayments: 'Bill payments',
            writeOffs: 'Write-offs',
            bills: 'Bills list',
        },
        presets: {
            month: 'Month',
            quarter: 'Quarter',
            year: 'Year',
            custom: 'Custom',
        },
        filters: {
            period: 'Period',
            granularity: 'Granularity',
            startLocal: 'Start (local)',
            endLocal: 'End (local)',
            table: 'Table filter',
            allTables: 'All',
            day: 'Day',
        },
        tablePeriod: {
            day: 'Day',
            month: 'Month',
            year: 'Year',
        },
        granularity: {
            day: 'Day',
            week: 'Week',
            month: 'Month',
        },
        columns: {
            period: 'Period',
            table: 'Table',
            total: 'Total',
            income: 'Income',
            withoutPay: 'Without pay',
            commercial: 'Commercial',
            commercialMinutes: 'Commercial min',
            commercialMin: 'Commercial, m',
            totalMinutes: 'Total min',
            minutes: 'Min',
            time: 'Time',
            actor: 'User',
            action: 'Action',
            summary: 'Summary',
            targetUser: 'Account',
            bonusDelta: 'Bonus',
            type: 'Type',
            balanceAfter: 'Balance',
            changedBy: 'Changed by',
            revision: 'Rev',
            role: 'Role',
            enabled: 'Enabled',
            player: 'Player',
            amount: 'Amount',
            paymentMethod: 'Method',
            closeNote: 'Note',
        },
        paymentTypes: {
            cash: 'Cash',
            card: 'Card',
            bonus: 'Bonus',
        },
        sections: {
            byTariff: 'By tariff (session pricing)',
            byTariffMinutes: 'By tariff (minutes)',
            tariffSplit: 'Tariff split for {{table}}',
            paymentChart: 'By payment type (up to {{count}} series)',
            tariffMinutesChart: 'Minutes by tariff (up to {{count}} series)',
            totalPaid: 'Total paid (UAH)',
            playTime: 'Play time (minutes)',
        },
        insights: {
            show: 'Show insights',
            hide: 'Hide insights',
        },
        views: {
            table: 'Table',
            insights: 'Insights',
        },
        actions: {
            clearTable: 'Clear table filter',
        },
        hints: {
            tableFilter: 'Choose a table above or tap a row to load table trends.',
        },
        audit: {
            systemActor: 'System',
            enabledYes: 'Yes',
            enabledNo: 'No',
            tableActionSummary: '{{user}} did {{action}} for {{table}}',
            tableActions: {
                START: 'start',
                PAUSE: 'pause',
                RESUME: 'resume',
                STOP: 'stop',
                FINISH_SET: 'finish set',
                MARK_LEFT: 'mark left',
            },
            bonusTypes: {
                REGISTRATION: 'Registration',
                BIRTHDAY: 'Birthday',
                PAYMENT_ACCRUAL: 'Payment accrual',
                PAYMENT_REDEMPTION: 'Payment redemption',
                ADMIN_ADJUST: 'Admin adjust',
                ADMIN_SET: 'Admin set',
            },
        },
        empty: {
            money: 'No paid lines in this window.',
            tables: 'No table data in this window.',
            military: 'No military tariff usage in this window.',
            tariffUsage: 'No tariff usage minutes in this window.',
            paymentChart: 'No data in this period for the chart.',
            tariffUsageChart: 'No tariff usage data in this period for the chart.',
            tableChart: 'Select a table to see trend charts.',
            tableActions: 'No table actions for this day.',
            bonuses: 'No bonus changes for this day.',
            userChanges: 'No user privilege changes for this day.',
            billPayments: 'No bill payments for this day.',
            writeOffs: 'No write-offs for this day.',
            bills: 'No bills in this period.',
            militaryTariffs: 'No military tariff usage in this period.',
            bonusActions: 'No bonus changes in this period.',
            peakHours: 'No sessions started in this period.',
            tableOccupancy: 'No occupancy data for this period.',
            topSpenders: 'No paid spending by registered customers in this period.',
            loyaltyHealth: 'No loyalty activity in this period.',
            tableActivity: 'No table activity in this period.',
            billsList: 'No bills in this period.',
        },
        errors: {
            invalidPeriod: 'Choose a valid period. For Custom, enter local datetimes.',
            loadMoney: 'Failed to load money report',
            loadTables: 'Failed to load table activity report',
            loadMilitary: 'Failed to load military tariff report',
            loadTariffUsage: 'Failed to load tariff usage report',
            loadBills: 'Failed to load bills',
            loadAudit: 'Failed to load audit report',
        },
        military: {
            minutes: 'Minutes',
            amount: 'Amount',
            sets: 'Sets',
            period: 'Period',
            hoursApprox: '~{{hours}} h',
        },
    },
    bills: {
        title: 'Bills',
        loading: 'Loading bills...',
        empty: 'No bills for the selected date and filters.',
        emptyLines: 'No unpaid lines for the selected players.',
        filters: {
            table: 'Table',
            all: 'All',
            status: 'Status',
            player: 'Player',
            noPlayers: 'No unpaid players',
        },
        status: {
            NEW: 'New',
            PARTIALLY_CLOSED: 'Partial',
            CLOSED: 'Closed',
        },
        columns: {
            start: 'Start',
            end: 'End',
            table: 'Table',
            status: 'Status',
            total: 'Total',
            paidByType: 'Paid by type',
            createdUpdated: 'Created / updated',
            player: 'Player',
            lineAmount: 'Amount',
            payment: 'Payment',
        },
        errors: {
            load: 'Failed to load bills',
            loadBill: 'Failed to load bill',
        },
        detail: {
            closeBill: 'Close bill',
            closeLine: 'Close bill',
            closeWithoutPayment: 'Close without payment',
            paid: 'Paid',
            paidAt: 'Paid: {{time}}',
            closedAtBy: 'Closed at {{time}} by {{method}}',
            closedBy: 'Closed by {{method}}',
            closedWithoutPayment: 'Closed without payment',
            closedWithoutPaymentAt: 'Closed without payment at {{time}}',
            note: 'Note',
            guest: 'Guest',
            loadingBill: 'Loading bill...',
            notFound: 'Bill not found.',
            billTitle: 'Bill #{{id}}',
            gameSession: 'Game session',
            start: 'Start',
            end: 'End',
            table: 'Table',
            segmentLine: '{{tariff}} - {{minutes}} min - {{amount}}',
            lineTotal: 'Total',
            grandTotal: 'TOTAL',
            printBill: 'Print Bill',
            printing: 'Printing...',
            tariffFallback: 'Tariff',
            editClosed: 'Edit payment',
            splitLine: 'Split',
            unassigned: 'Unassigned',
            lineTypes: {
                PLAY: 'Play',
                VIDEO_RECORDING: 'Video recording',
                FOUL_REVIEW: 'Foul review',
                CLIP_EDITING: 'Clip editing',
                LATE_VIDEO_RECORDING: 'Late video recording',
            },
        },
        notifications: {
            printSuccess: 'Bill sent to printer.',
            printFailed: 'Failed to print bill',
            closedSuccess: 'Bill closed successfully',
            closeFailed: 'Failed to close bill',
        },
        closeWithoutPayment: {
            titleLine: 'Close bill line without payment',
            titleWhole: 'Close bill without payment',
            confirm: 'Do you really need to close the bill without payment?',
            noteLabel: 'Note',
            notePlaceholder: 'Reason for closing without payment',
            noteRequired: 'Please enter a note',
            cancel: 'Cancel',
            confirmButton: 'Close',
            success: 'Bill closed without payment',
            failed: 'Failed to close bill without payment',
        },
        splitBill: {
            title: 'Split bill line',
            subtitle: '{{player}} — {{amount}}',
            playerPlaceholder: 'Player name...',
            addPlayer: 'Add player',
            splitSum: 'Split total',
            splitTotalMismatch: 'Split must equal {{expected}} (got {{actual}})',
            playerNameRequired: 'Enter a player name for each line',
            invalidPartAmount: 'Each share amount must be greater than zero',
            needMultipleParts: 'Add at least two players to split the bill',
            confirm: 'Split',
            success: 'Bill line split successfully',
            failed: 'Failed to split bill line',
        },
        editClosed: {
            title: 'Edit closed bill line',
            method: 'Payment method',
            allocations: 'Payment amounts',
            success: 'Closed bill line updated',
            failed: 'Failed to update closed bill line',
            splitMismatch: 'Amounts must equal {{expected}} (got {{actual}})',
            methods: {
                CASH: 'Cash',
                CARD: 'Card',
                BONUS: 'Bonus',
                WITHOUT_PAYMENT: 'Without payment',
            },
        },
    },
    booking: {
        title: 'Bookings',
        back: 'Dashboard',
        loading: 'Loading availability...',
        today: 'Today',
        tableFallback: 'Table {{id}}',
        wizard: {
            back: 'Back',
            close: 'Close',
        },
        stream: {
            free: 'Free',
            inPlay: 'In play',
            book: 'Book',
            view: 'View',
            selectedSlotRange: 'Selected slot: {{start}} – {{end}}',
            freeHeader: '{{range}} · FREE',
            bookedHeader: '{{range}} · BOOKED',
            sessionHeader: '{{range}} · IN PLAY',
        },
        form: {
            newTitle: 'New reservation',
            editTitle: 'Booking details',
            timeSlot: 'Time slot',
            startTime: 'Start time',
            endTime: 'End time',
            hourLabel: 'Hour',
            durationLabel: 'Duration',
            customerLookup: 'Customer lookup',
            customerReadOnly: 'Customer',
            customerReadOnlyNote: 'To change the customer, cancel this booking and create a new one.',
            searchUser: 'Find registered user',
            orGuest: 'Or guest details',
            guestName: 'Guest name',
            guestPhone: 'Phone (optional)',
            selectedUser: 'Booking for {{name}}',
            playerCount: 'Cue / player count',
            playerCountPlaceholder: 'e.g. 2',
            playerCountNote: 'Optional — for your reference only; not saved to the booking.',
            makeRecurring: 'Make Recurring',
            recurringComingSoon: 'Recurring bookings — coming soon.',
            confirm: 'Save booking',
            confirmPending: 'Confirm booking',
            save: 'Save changes',
            cancelBooking: 'Cancel booking',
            startTable: 'Start table',
            timeConflict: 'Selected time overlaps with an existing booking.',
        },
        notifications: {
            created: 'Booking confirmed.',
            updated: 'Booking updated.',
            cancelled: 'Booking cancelled.',
            unavailable: 'Table is not available for the selected time.',
            failed: 'Failed to save booking.',
        },
        pendingReview: {
            requestedSlotRange: 'Requested: {{start}} – {{end}}',
            tableTypeMismatch: 'Select a table of the requested type.',
        },
    },
    markerNotifications: {
        title: 'Notifications',
        empty: 'No pending notifications.',
        emptyHistory: 'No notifications in the last retention period.',
        emptyImportant: 'No important notifications.',
        emptyNotice: 'No notice notifications.',
        emptyImportantHistory: 'No important notifications in the last retention period.',
        emptyNoticeHistory: 'No notice notifications in the last retention period.',
        viewHistory: 'View whole history',
        backToInbox: 'Back to inbox',
        unknownActor: 'Someone',
        noticeDismissHint: 'Tap to dismiss',
        overdueBooking: 'Overdue booking · {{tableName}}',
        overdueHint: 'Guest may be late — call and update or cancel the booking.',
        alertBanner: {
            message: '{{count}} important — tap to review',
        },
        alert: {
            bookingRequest: 'New booking request ({{tableType}})',
            overdue: 'Overdue booking on {{tableName}}',
            inquiry: 'Booking inquiry ({{tableType}})',
        },
        browserAlerts: {
            title: 'Browser alerts',
            message: 'Enable notifications to get alerted when the Dashboard tab is in the background.',
            enable: 'Enable alerts',
            notNow: 'Not now',
            blockedHint: 'Notifications are blocked in your browser. Allow them in site settings to receive background alerts.',
            iosHint: 'On iPhone: Add to Home Screen for reliable background alerts.',
        },
        resolve: {
            title: 'Resolve booking request',
            message: 'Add an optional note about how this request was handled.',
            notePlaceholder: 'Note (optional)',
            confirm: 'Resolve',
            openBooking: 'Open booking',
            resolvedByAt: 'Resolved by {{name}} at {{time}}',
            resolvedAt: 'Resolved at {{time}}',
            resolutionNote: 'Note: {{note}}',
            tapHint: 'Tap to resolve',
        },
        priority: {
            IMPORTANT: 'Important',
            NOTICE: 'Notice',
        },
        status: {
            ACTIVE: 'Active',
            DISMISSED: 'Dismissed',
            RESOLVED: 'Resolved',
        },
        tableAction: {
            START: '{{actorName}} started "{{tableName}}"',
            PAUSE: '{{actorName}} paused "{{tableName}}"',
            RESUME: '{{actorName}} resumed "{{tableName}}"',
            STOP: '{{actorName}} stopped "{{tableName}}"',
            FINISH_SET: '{{actorName}} finished a set on "{{tableName}}"',
            MARK_LEFT: '{{actorName}} marked a player left on "{{tableName}}"',
        },
        videoExportError: {
            title: 'Video export error · {{tableName}}',
        },
        row: {
            date: 'Date',
            time: 'Time',
            slot: 'Slot',
            user: 'User',
            actor: 'Actor',
            phone: 'Phone',
            notes: 'Notes',
            tableType: 'Table type',
            error: 'Error',
        },
    },
    loyalty: {
        title: 'Loyalty program',
        bonusBalance: 'Bonus balance',
        loyaltyPercent: 'Loyalty level',
        loyaltyPercentValue: '{{percent}}%',
        levelLabel: 'Loyalty level',
        levelValue: '{{level}} · {{percent}}%',
        tiers: {
            bronze: 'Bronze',
            silver: 'Silver',
            gold: 'Gold',
            platinum: 'Platinum',
        },
        infoTitle: 'How loyalty works',
        infoClose: 'Got it',
        infoIntro:
            'Right after registration you receive 50 UAH on your bonus balance.',
        infoCashback:
            'You also earn from 5% to 20% back on every receipt — the more you play, the higher your level:',
        infoTierBronze: 'Bronze — up to 7,000 UAH spent → 5%',
        infoTierSilver: 'Silver — from 7,001 to 12,000 UAH → 10%',
        infoTierGold: 'Gold — from 12,001 to 20,000 UAH → 15%',
        infoTierPlatinum: 'Platinum — from 20,001 UAH → 20%',
        infoBirthday:
            'And that is not all: on your birthday, BP Cluster gifts you 200 UAH on your bonus balance.',
        bonusesUnit: 'bonuses',
        registrationBonus: 'Registration bonus',
        birthdayBonus: 'Birthday bonus',
        graceDays: 'Tier grace period (days)',
        tiersTitle: 'Spend tiers (12 months, cash + card)',
        tierMin: 'Min spend (UAH)',
        tierMax: 'Max spend (UAH)',
        tierPercent: 'Cashback %',
        save: 'Save settings',
        saved: 'Loyalty settings saved.',
        loadFailed: 'Failed to load loyalty settings.',
        cabinetTitle: 'Loyalty',
        cabinetHint: 'Bonuses can cover up to 50% of your bill.',
        closeBill: {
            titleLine: 'Close Bill Line',
            titleWhole: 'Close Whole Bill',
            whoPays: 'Who is paying?',
            bonusBalance: 'Bonus balance',
            bonusesToUse: 'Bonuses to use',
            total: 'Total',
            bonuses: 'Bonuses',
            toPay: 'To pay',
            payCash: 'Cash',
            payCard: 'Card',
            confirmPay: 'Confirm payment',
            waiting: 'Waiting for payment confirmation…',
            selectPayer: 'Please select who is paying',
            invalidBonus: 'Invalid bonus amount',
            maxBonus: 'Max bonus: {{amount}} (50% rule)',
            paymentFailed: 'Payment failed',
            noteLabel: 'Note',
            notePlaceholder: 'Optional note (e.g. clicked Card by mistake)',
        },
        userManagement: {
            bonusBalance: 'Bonuses',
            loyaltyRate: 'Loyalty level',
            adjustBonus: 'Adjust bonuses (+/-)',
            setBalance: 'Set balance',
            deltaPlaceholder: '+50 or -10',
            balancePlaceholder: '0',
            note: 'Note (optional)',
            apply: 'Apply',
            birthdayBlocked: 'Birthday bonus blocked',
            revalidateBirthday: 'Revalidate birth date',
            revalidated: 'Birthday eligibility restored.',
            adjustNonZero: 'Enter a non-zero adjustment',
            invalidBalance: 'Enter a valid balance',
            updateFailed: 'Failed to update bonuses',
            revalidateFailed: 'Failed to revalidate',
            updated: 'Bonus balance updated.',
        },
    },
    ratings: {
        title: 'Ratings',
        loadFailed: 'Failed to load ratings.',
        loading: 'Loading…',
        yourRating: 'Your rating',
        yourPlace: 'Place {{place}}',
        searchPlaceholder: 'Find player on the board…',
        types: {
            pyramidAllBalls: 'Pyramid all balls',
            pyramidOneBall: 'Pyramid one ball',
            pool: 'Pool',
        },
        table: {
            place: '#',
            name: 'Player',
            rating: 'Elo',
            empty: 'No players yet',
        },
        history: {
            title: '{{name}} — match history',
            titleFallback: 'Match history',
            section: 'Your matches',
            ratingLine: 'Rating {{rating}} · {{matches}} matches',
            empty: 'No matches yet',
            loadFailed: 'Failed to load history.',
        },
        match: {
            title: 'Enter match',
            playerA: 'Player A',
            playerB: 'Player B',
            searchPlayer: 'Search registered player…',
            submit: 'Save match',
            selectPlayers: 'Select both players',
            invalidScores: 'Enter valid non-negative scores',
            noDraws: 'Draws are not allowed',
            winner: 'Winner',
            loser: 'Loser',
            saved: 'Match saved.',
            saveFailed: 'Failed to save match.',
            updated: 'Match updated.',
            updateFailed: 'Failed to update match.',
            deleted: 'Match deleted.',
            deleteFailed: 'Failed to delete match.',
        },
        adjust: {
            title: 'Set rating (silent)',
            placeholder: 'Rating',
            apply: 'Set',
            invalid: 'Enter a valid rating',
            saved: 'Rating updated.',
            failed: 'Failed to update rating.',
        },
        userManagement: {
            title: 'Elo ratings',
            meta: 'Rating {{rating}} · {{matches}} matches',
        },
        openButton: 'Ratings',
        recentMatches: {
            button: 'History',
            title: 'Recent matches',
            loadFailed: 'Failed to load recent matches.',
            empty: 'No matches yet.',
            columns: {
                date: 'Date',
                score: 'Score',
                deltaA: 'ΔA',
                deltaB: 'ΔB',
            },
        },
        tournament: {
            button: 'Tournaments',
            listTitle: 'Tournaments',
            noTournaments: 'No tournaments yet.',
            participants: '{{count}} participants',
            createTitle: 'New tournament',
            namePlaceholder: 'Tournament name',
            create: 'Create',
            createFailed: 'Failed to create tournament.',
            loadFailed: 'Failed to load tournaments.',
            detailLoadFailed: 'Failed to load tournament.',
            addParticipantSearch: 'Search player to add…',
            addParticipant: 'Add',
            addParticipantFailed: 'Failed to add participant.',
            removeParticipantFailed: 'Failed to remove participant.',
            participantColumns: {
                elo: 'Elo',
                player: 'Player',
            },
            matchTitle: 'Add match',
            selectPlayer: 'Select player…',
            submitMatch: 'Save match',
            matchSaved: 'Match saved.',
            matchSaveFailed: 'Failed to save match.',
            deleteTournament: 'Delete tournament',
            deleteConfirm: 'Delete this tournament?',
            deleteCancel: 'Cancel',
            deleted: 'Tournament deleted.',
            deleteFailed: 'Failed to delete tournament.',
        },
    },
    settings: {
        title: 'Settings',
        sections: {
            communicationChannels: 'Communication channels',
            markerNotifications: 'Marker notifications',
            tariffs: 'Tariffs',
            loyalty: 'Loyalty program',
            videoSettings: 'Video upload (YouTube)',
            videoPricing: 'Video pricing',
        },
        communicationChannels: {
            email: 'Email',
            telegram: 'Telegram',
            save: 'Save notification settings',
            saved: 'Notification settings saved.',
            loadFailed: 'Failed to load notification settings.',
            categories: {
                registrationAuth: 'Registration / password reset',
                registrationAuthHint: 'Registration confirmation, email change, activation, password reset',
                loyalty: 'Loyalty',
                bills: 'Bills',
            },
        },
        videoSettings: {
            sectionTitle: 'Video upload (YouTube)',
            defaultHashtags: 'Default hashtags',
            defaultHashtagsPlaceholder: '#billiards #pool #snooker',
            descriptionTemplate: 'Description template',
            descriptionTemplatePlaceholder: 'Recorded at Club Name',
            youtubeStatus: 'YouTube connection',
            connected: 'Connected · {{channel}}',
            notConnected: 'Not connected',
            connectBtn: 'Connect YouTube account',
            revokeHint: 'To fully revoke access, visit Google Account Permissions.',
            reAuthBtn: 'Re-authorize',
            disconnectBtn: 'Disconnect',
            disconnected: 'YouTube account disconnected.',
            save: 'Save',
            saved: 'Video settings saved.',
            saveFailed: 'Failed to save video settings.',
            loadFailed: 'Failed to load video settings.',
            ytConnectedSuccess: 'YouTube account connected successfully.',
            notConfigured: 'YouTube client credentials are not set up on the server (YOUTUBE_CLIENT_ID/SECRET).',
            channelsTitle: 'Reserve YouTube channels',
            channelsHint: 'Streams try channels in this order and skip to the next one if a channel hits its quota or its token expired. Google tokens expire after about a week — reconnect before they do.',
            addChannel: 'Add channel',
            noChannels: 'No channels connected yet.',
            channelReconnect: 'Reconnect',
            channelDisconnect: 'Disconnect',
            channelDelete: 'Remove',
            channelDeleteConfirm: 'Remove this channel from the reserve list?',
            channelMoveUp: '↑',
            channelMoveDown: '↓',
            channelStatus: {
                CONNECTED: 'Connected',
                EXPIRING_SOON: 'Expiring soon',
                EXPIRED: 'Expired — reconnect',
                NOT_CONNECTED: 'Not connected',
            },
            events: {
                title: 'Stream events log',
                empty: 'No stream events yet.',
                manualKey: 'Manual key',
                tableChannel: 'Table {{table}} · {{channel}}',
                prev: '← Prev',
                next: 'Next →',
                type: {
                    CREATED: 'Created',
                    REUSED: 'Reused',
                    FAILED: 'Failed',
                    TRANSITIONED_LIVE: 'Went live',
                    TRANSITIONED_COMPLETE: 'Completed',
                },
            },
        },
        videoPricing: {
            videoUahPerHour: 'Full video recording',
            lateUahPerHour: 'Late recording',
            foulUahFlat: 'Fault review',
            clipBase: 'Clip editing — base price',
            clipFreeMinutes: 'Base includes (min)',
            clipPerMin: 'Clip — per extra minute',
            unitHour: 'UAH/hr',
            unitFlat: 'UAH',
            unitMin: 'UAH/min',
            unitMinutes: 'min',
            save: 'Save prices',
            saved: 'Video prices saved.',
            saveFailed: 'Failed to save video prices.',
            loadFailed: 'Failed to load video prices.',
        },
        markerNotifications: {
            hint: 'Important items blink and alert staff. Notice items only increase the counter. Off disables creation.',
            retentionDays: 'History retention (days)',
            retentionInvalid: 'Retention must be between 1 and 90 days.',
            save: 'Save marker notification settings',
            saved: 'Marker notification settings saved.',
            loadFailed: 'Failed to load marker notification settings.',
            modes: {
                important: 'Important',
                notice: 'Notice',
                off: 'Off',
            },
            types: {
                bookingRequest: 'Booking requests',
                overdueBooking: 'Overdue bookings',
                tableActions: 'Table actions',
            },
        },
    },
    common: {
        duplicateValue: "Field '{{field}}' is already in use",
        fieldNames: {
            email: 'Email',
            phone: 'Phone',
            full_name: 'Full name',
        },
        cancel: 'Cancel',
        confirm: 'Confirm',
        back: 'Back',
        save: 'Save',
        create: 'Create',
        search: 'Search',
        retry: 'Retry',
        yes: 'Yes',
        no: 'No',
        delete: 'Delete',
        edit: 'Edit',
        all: 'All',
        next: 'Next',
        previous: 'Previous',
        close: 'Close',
        continue: 'Continue',
        login: 'Login',
        register: 'Register',
        loading: 'Loading...',
        comingSoon: 'Coming soon',
        comingSoonFeature: '{{feature}} is coming soon.',
        notAvailable: 'N/A',
        datePlaceholder: 'YYYY-MM-DD',
        active: 'Active',
        userView: '👤 User view',
        adminView: '🎱 Admin view',
        telegramBotBlocked: 'Telegram notifications are disabled. Please unblock the Pool Control bot to receive alerts.',
    },
    dashboard: {
        loadingTitle: 'Pool Tables',
        loadingMessage: 'Loading tables...',
        title: 'Pool Control Dashboard',
        welcome: 'Welcome, {{name}} ({{role}})',
        logout: 'Logout',
        stats: {
            totalTables: 'Tables',
            active: 'Active',
            paused: 'Paused',
            idle: 'Idle',
            bills: 'Bills',
            users: 'Users',
            tariffs: 'Tariffs',
            loyalty: 'Loyalty',
            reports: 'Reports',
            bookings: 'Bookings',
            rivalSearch: 'Rival search',
            ratings: 'Ratings',
            video: 'Video',
            settings: 'Settings',
            notifications: 'Notifications',
        },
        legendTitle: 'Status Legend:',
        legend: {
            idle: 'Idle (Available)',
            paused: 'Paused',
            active: 'Active (In Use)',
            booked: 'Booked',
            maintenanceOffline: 'Maintenance/Offline',
            error: 'Error',
        },
        noTables: 'No tables registered in the system',
    },
    auth: {
        login: {
            title: 'Welcome Back',
            subtitle: 'Login to your {{clubName}} account',
            emailOrPhone: 'Email or phone',
            emailOrPhoneRequired: 'Email or phone is required',
            emailOrPhoneInvalid: 'Enter a valid email or phone in +380... format',
            emailOrPhonePlaceholder: 'Email or phone in +380... format',
            password: 'Password',
            passwordRequired: 'Password is required',
            passwordPlaceholder: 'Enter your password',
            forgotPassword: 'Forgot password?',
            continue: 'Continue',
            login: 'Login',
            back: 'Back',
            cancel: 'Cancel',
            continueGoogle: 'Continue with Google',
            continueApple: 'Continue with Apple ID',
            activationSent: 'We sent an activation link{{destination}}. Open the link to create your password and finish setup.',
            activationDestination: ' to {{hint}}',
            openTelegramBot: 'Open Telegram bot',
            resendActivation: 'Resend activation link',
            notFound: "We couldn't find an account with this phone or email. Please contact your administrator.",
            socialHint: 'Use {{provider}} to sign in with this account.',
            socialHintFallback: 'Google or Apple',
        },
        register: {
            title: 'Create Account',
            subtitle: 'Join Pool Control System',
            tabEmail: 'Email',
            tabPhone: 'Phone',
            tabTelegram: 'Telegram',
            tabSocial: 'Social',
            openTelegramBot: 'Open Telegram bot',
            telegramSubtitle: 'Register in Telegram — open the bot, share your phone, then finish in the app.',
            consent: 'I allow storing my personal information for account and billing purposes.',
            consentRequired: 'Consent is required to register.',
            register: 'Register',
            cancel: 'Cancel',
            continueGoogle: 'Continue with Google',
            continueApple: 'Continue with Apple ID',
            socialNote: 'You will sign in with Google or Apple next time. No password needed.',
            telegramInviteSubtitle: 'Finish registration — your phone is from Telegram.',
            inviteInvalid: 'This Telegram registration link is invalid or expired. Scan the club QR code again.',
        },
        activation: {
            title: 'Create your password',
            password: 'Enter new password',
            confirmPassword: 'Confirm new password',
            dob: 'Date of birth (optional)',
            dobPlaceholder: 'YYYY-MM-DD',
            photoUrl: 'Profile photo URL (optional)',
            photoPlaceholder: 'https://...',
            finishSetup: 'Finish setup',
            skipOptional: 'Skip optional fields',
        },
        registrationPending: {
            title: 'Complete registration',
            subtitle: 'Follow the steps below to activate your account.',
            confirmEmail: 'Confirm your email',
            confirmEmailBody: 'We sent a link to {{destination}}. Open it to verify your address.',
            resendEmail: 'Resend email',
            confirmPhone: 'Confirm your phone (SMS)',
            confirmPhoneBody: 'We sent a link to {{destination}}. Open it to verify.',
            resendSms: 'Resend SMS',
            confirmTelegram: 'Confirm in Telegram',
            confirmTelegramBody: 'We sent a confirmation link to @Cluster_palace_bot. Open it to finish registration.',
            verifyTelegram: 'Verify phone in Telegram',
            telegramBody: 'Open @Cluster_palace_bot and share your contact to verify your phone number.',
            telegramHint: 'Bill receipts can also be sent to your email if Telegram is not connected.',
            openTelegram: 'Open Telegram',
            continueApp: 'Continue to app',
            backHome: 'Back to home',
            yourEmail: 'your email',
            yourPhone: 'your phone',
        },
        forgotPassword: {
            title: 'Reset password',
            subtitle: 'Enter your email or phone. We will send a reset link to your Telegram or email.',
            emailOrPhone: 'Email or phone',
            emailOrPhonePlaceholder: 'Enter your email or phone number',
            emailOrPhoneRequired: 'Email or phone is required',
            submit: 'Send reset link',
            sent: 'If an account exists, we sent a password reset link{{destination}}. Open the link to choose a new password.',
            sentDestination: ' to {{hint}}',
            resend: 'Resend link',
            backToLogin: 'Back to login',
            close: 'Close',
        },
        passwordReset: {
            title: 'Choose a new password',
            password: 'New password',
            confirmPassword: 'Confirm new password',
            submit: 'Reset password',
            success: 'Your password has been reset. Please sign in with your new password.',
        },
    },
    splash: {
        title: 'Pool Control',
        tagline: 'Manage your pool tables efficiently',
        login: 'Login',
        register: 'Register',
        continueApp: 'Continue to app',
        logout: 'Log out',
    },
    userManagement: {
        title: 'User Management',
        searchPlaceholder: 'Search by name, email, phone...',
        addUser: '+ Add User',
        empty: 'No users match the selected filters.',
        email: 'Email: {{value}}',
        phone: 'Phone: {{value}}',
        role: 'Role: {{role}}',
        deleteConfirm: 'Delete?',
        pageOf: 'Page {{page}} of {{total}}',
        notifications: {
            updated: 'User updated successfully',
            created: 'User created successfully',
            deleted: 'User deleted successfully',
            saveFailed: 'Failed to save user',
            deleteFailed: 'Failed to delete user',
        },
    },
    userMerge: {
        openButton: 'Merge accounts',
        title: 'Merge accounts',
        hint: 'Exceptional fix: join two duplicate accounts into one. History and bonuses move to the kept account.',
        leftAccount: 'Left account',
        rightAccount: 'Right account',
        searchPlaceholder: 'Search by name, email, phone...',
        compare: 'Compare',
        preview: 'Preview result',
        confirm: 'Confirm merge',
        keepAccount: 'Keep account id:',
        keepLeft: 'Left #{{id}}',
        keepRight: 'Right #{{id}}',
        field: 'Field',
        left: 'Left',
        right: 'Right',
        pick: 'Pick',
        result: 'Result',
        loyaltyTitle: 'Loyalty',
        loyaltyLine: 'Bonuses: left {{left}} + right {{right}} → {{result}}',
        historyTitle: 'History moved to survivor',
        historyLine: 'Bill lines {{leftBills}}/{{rightBills}}, bookings {{leftBookings}}/{{rightBookings}} (left/right)',
        discardNote: 'Account #{{id}} will be deleted after merge.',
        fields: {
            fullName: 'Full name',
            email: 'Email',
            phone: 'Phone',
            birthDate: 'Birth date',
            photoUrl: 'Photo URL',
            role: 'Role',
            authProvider: 'Auth provider',
            telegramChatId: 'Telegram chat',
            billNotificationChannel: 'Bill notifications',
            preferredLocale: 'Locale',
            enabled: 'Enabled',
        },
        errors: {
            pickTwoDifferent: 'Select two different users to compare.',
            previewFailed: 'Failed to build merge preview.',
            mergeFailed: 'Failed to merge accounts.',
        },
        notifications: {
            merged: 'Accounts merged successfully.',
        },
    },
    userForm: {
        createTitle: 'Create New User',
        editTitle: 'Edit User',
        registerTitle: 'Create Account',
        fullName: 'Full Name *',
        fullNamePlaceholder: 'Enter full name',
        email: 'Email',
        emailRequired: 'Email *',
        emailOptional: 'Email (optional)',
        emailPlaceholder: 'Enter email',
        phone: 'Phone',
        phoneRequired: 'Phone *',
        phoneOptional: 'Phone (optional)',
        phonePlaceholder: 'Enter phone (E.164, e.g. +380...)',
        phoneFromTelegram: 'Phone number shared via Telegram',
        telegramChatId: 'Telegram Chat ID',
        telegramChatIdPlaceholder: 'Numeric chat id from the bot',
        telegramChatIdHint: 'Leave empty to unlink. Client can get Chat ID from the club bot after /start.',
        password: 'Password *',
        passwordPlaceholder: 'Enter password (min 8 characters)',
        confirmPassword: 'Confirm Password *',
        confirmPasswordPlaceholder: 'Confirm password',
        role: 'Role',
        roleWarning: "You don't have permission to change this user's role",
        specialStatus: 'Special status',
        military: 'Military',
        militaryHintAdmin: 'Only Admin+ after document check. User cannot set this themselves.',
        militaryHintMarker: 'Only Admin or Superadmin can change military status.',
        activationNote: 'Note: User will activate access on first login',
        birthDate: 'Birth date',
        birthDateOptional: 'Optional — can only be set once',
        birthDateLocked: 'Birth date can only be set once.',
        errors: {
            fullNameRequired: 'Full name is required',
            fullNameMin: 'Full name must be at least 2 characters',
            emailRequired: 'Email is required',
            phoneRequired: 'Phone is required',
            contactRequired: 'Enter at least email or phone',
            invalidEmail: 'Invalid email format',
            invalidPhone: 'Phone must start with + followed by digits (e.g. +380...)',
            passwordRequired: 'Password is required',
            passwordMin: 'Password must be at least 8 characters',
            confirmRequired: 'Please confirm your password',
            passwordMismatch: 'Passwords do not match',
        },
    },
    userCabinet: {
        title: 'Account settings',
        subtitle: 'Your personal cabinet',
        profile: 'Profile',
        notifications: 'Notifications',
        security: 'Security',
        editProfile: 'Edit profile',
        editProfileMessage: 'Update name, contact details, and birth date.',
        profileEditTitle: 'Your profile',
        profileEditSubtitle: 'Update your personal details',
        billCheckChannel: 'Bill check channel',
        billCheckMessage: 'Choose Telegram or email for bill receipts.',
        changePassword: 'Change password',
        changePasswordMessage: 'Change password with current password verification.',
        changePasswordModal: {
            title: 'Change password',
            currentPassword: 'Current password',
            newPassword: 'New password',
            confirmPassword: 'Confirm new password',
            submit: 'Update password',
            cancel: 'Cancel',
            success: 'Password updated successfully.',
        },
    },
    tariffManagement: {
        title: 'Tariff Management',
        moveUp: 'Move up',
        moveDown: 'Move down',
        addTariff: '+ Add tariff',
        columns: {
            name: 'Name',
            price: 'Price',
            when: 'When',
            kind: 'Type',
            priority: 'Priority',
            active: 'Active',
        },
        empty: 'No tariffs for this table type',
    },
    tariffEdit: {
        addTitle: 'Add tariff',
        editTitle: 'Edit tariff',
        name: 'Name',
        namePlaceholder: 'Tariff name',
        tableType: 'Table type',
        pricePerHour: 'Price per hour (UAH)',
        startTime: 'Start time (HH:mm, optional)',
        endTime: 'End time (HH:mm, optional)',
        daysOfWeek: 'Days of week (leave empty = all days)',
        tariffKind: 'Tariff type',
        priority: 'Priority (higher = checked first)',
        active: 'Active',
        errors: {
            nameRequired: 'Name is required',
            invalidPrice: 'Invalid price',
            overnightRange: 'Overnight ranges (e.g. 23:00–08:00) are not allowed as a single tariff. Create two tariffs instead: e.g. 23:00–23:59 and 00:00–08:00.',
            saveFailed: 'Save failed',
        },
        notifications: {
            created: 'Tariff created',
            updated: 'Tariff updated',
        },
    },
    tariffRule: {
        allDays: 'All days',
        allDay: 'all day',
        allDaysAllDay: 'All days, all day',
        from: 'from {{time}}',
        until: 'until {{time}}',
    },
    enums: {
        tableStatus: {
            IDLE: 'Idle',
            ACTIVE: 'Active',
            PAUSED: 'Paused',
            MAINTENANCE: 'Maintenance',
            OFFLINE: 'Offline',
            ERROR: 'Error',
            BOOKED: 'Booked',
        },
        tableType: {
            POOL: 'Pool',
            PYRAMID: 'Pyramid',
            SNOOKER: 'Snooker',
            VIP: 'VIP',
        },
        userRole: {
            USER: 'User',
            MARKER: 'Marker',
            ADMIN: 'Admin',
            SUPERADMIN: 'Super Admin',
            SERVICE: 'Service',
        },
        bookingStatus: {
            PENDING: 'Pending',
            CONFIRMED: 'Confirmed',
            CANCELLED: 'Cancelled',
            COMPLETED: 'Completed',
            NO_SHOW: 'No Show',
        },
        daysOfWeek: {
            MONDAY: 'Mon',
            TUESDAY: 'Tue',
            WEDNESDAY: 'Wed',
            THURSDAY: 'Thu',
            FRIDAY: 'Fri',
            SATURDAY: 'Sat',
            SUNDAY: 'Sun',
        },
        tariffKind: {
            USUAL: 'Usual',
            MILITARY: 'Military',
            STUDENT: 'Student',
        },
    },
    searchableInput: {
        noResults: 'No results',
        searchFailed: 'Search failed',
        searching: 'Searching...',
        placeholder: 'Type to search...',
    },
    passwordField: {
        showPassword: 'Show password',
        hidePassword: 'Hide password',
    },
    playerSearch: {
        registered: 'Registered',
    },
    userDetails: {
        confirming: 'Confirming registration...',
        title: 'Complete your profile',
        subtitle: 'Add missing information to finish registration',
        fullName: 'Full name',
        fullNamePlaceholder: 'Your full name',
        email: 'Email',
        emailPlaceholder: 'your@email.com',
        emailReadOnlyHint: 'Email is managed by your sign-in provider and cannot be changed here.',
        emailChangePending: 'Confirmation sent to {{email}}. Check your inbox to confirm the new address.',
        emailChangeConfirmed: 'Your new email address has been confirmed.',
        emailConfirmationSent: 'Confirmation email sent. Check your inbox to confirm the new address.',
        phone: 'Phone *',
        phoneOptional: 'Phone',
        phonePlaceholder: '+380...',
        birthDate: 'Birth date',
        birthDatePlaceholder: '1990-01-01',
        birthDateLocked: 'Birth date can only be set once. Ask Marker to change it.',
        saveDetails: 'Save details',
        saved: 'Profile details saved.',
        profileUpdated: 'Profile updated.',
    },
    video: {
        title: 'Video',
        selectTable: 'Select a table',
        selectTableHint: 'Select a table with a camera to begin.',
        noCameraTables: 'No tables with cameras are configured.',
        tabs: {
            foulReview: 'Foul review',
            clipEdit: 'Clip editing',
            youtubeLive: 'YouTube Live',
        },
    },
    clipEditing: {
        title: 'Clip Editing',
        setIn: 'Set In Point',
        inSet: 'In: {{time}}',
        setOut: 'Set Out Point',
        outSet: 'Out: {{time}}',
        clear: 'Clear',
        duration: 'Clip duration: {{duration}}',
        invalidRange: 'Out point must be after in point.',
        notifyPlayer: 'Notify player via Telegram',
        noNotify: 'No notification',
        noTelegram: 'This player has no linked Telegram account.',
        exportQueued: 'Clip export queued.',
        submitFailed: 'Export failed: {{message}}',
        exportRunning: 'Exporting clip…',
        exportReady: 'Export ready!',
        download: 'Download',
        downloadFailed: 'Failed to generate download link.',
        exportFailed: 'Export failed: {{error}}',
        submit: 'Export clip',
        newClip: 'New clip',
        payerLabel: 'Payer / notify',
        payerPlaceholder: 'Search player…',
    },
    comingSoonBanner: {
        defaultMessage: 'This feature will be available in a future update.',
    },
    locale: {
        switchToEnglish: 'Switch to English',
        switchToUkrainian: 'Switch to Ukrainian',
    },
    streaming: {
        status: {
            live: 'LIVE',
            preparing: 'PREPARING',
            failed: 'FAILED',
        },
        form: {
            player1Name: 'Player 1',
            player2Name: 'Player 2',
            playerNamePlaceholder: 'Full name',
            handicap: 'Handicap',
            bestOf: 'Best of',
            matchDuration: 'Match time, minutes (OBS overlay)',
            matchDurationCustom: 'Custom',
            matchDurationHint: 'Total match countdown on the OBS overlay. Starts with the first shot-clock action and stops during a break. Leave empty for no match clock.',
            tournamentName: 'Tournament',
            stage: 'Tournament Stage',
            stagePlaceholder: 'e.g. Quarter Final',
            descriptionPrefix: 'Stream description',
            optional: 'Optional',
            channel: 'Channel',
            channelAuto: 'Auto (failover)',
        },
        controls: {
            startStream: 'Start Stream ▶',
            stopStream: 'Stop Stream',
            matchScore: 'Match wins',
            gameScore: 'Game score',
            break: 'Break ⏸',
            resume: 'Resume ▶',
            volume: 'Volume',
            apply: 'Apply',
            startObsSession: 'Start OBS overlay session',
            obsOverlayUrl: 'OBS overlay URL (Browser Source)',
            copyOverlayUrl: 'Copy overlay URL',
            obsHint: 'OBS session: start the YouTube broadcast and the stream in OBS yourself.',
            copyLink: 'Copy link',
            makePublic: 'Make Public',
            alreadyPublic: 'Public',
            noStreamUrl: 'No YouTube URL (manual stream key)',
            editDetails: 'Edit details',
            saveDetails: 'Save',
            cancelEditDetails: 'Cancel',
            clearTemplate: 'Clear saved template',
            liveVia: 'Live via:',
            commentary: 'Commentator mic',
            commentaryStart: 'Start',
            commentaryStop: 'Stop',
        },
        presets: {
            button: 'Saved settings',
            title: 'Saved stream settings',
            namePlaceholder: 'Preset name',
            saveNew: 'Save as new',
            load: 'Load',
            update: 'Update',
            delete: 'Delete',
            empty: 'No saved settings yet.',
            close: 'Close',
        },
        confirm: {
            winsPlus: 'Player {{name}} won the game?',
            winsMinus: 'Edit match count?',
            confirmBtn: 'Yes',
            cancelBtn: 'Cancel',
        },
        notifications: {
            streamStarted: 'Stream started.',
            streamStopped: 'Stream stopped.',
            streamFailed: 'Failed to start stream.',
            scoreSaved: 'Score updated.',
            breakStarted: 'Break started.',
            breakStopped: 'Break ended.',
            obsSessionStarted: 'OBS overlay session started.',
            overlayUrlCopied: 'Overlay URL copied to clipboard.',
            linkCopied: 'Link copied to clipboard.',
            madePublic: 'Stream is now public on YouTube.',
            detailsSaved: 'Details updated.',
            commentaryDropped: 'Commentary connection dropped.',
        },
        errors: {
            playerNamesRequired: 'Player names are required.',
            matchDurationInvalid: 'Match time must be between 1 and 600 minutes.',
            noStreamKey: 'No YouTube stream key configured for this table. Set it in Video Settings → YouTube Live.',
            micUnavailable: 'Could not access the microphone.',
        },
        settings: {
            streamTablesTitle: 'Stream Keys (per table)',
            streamKey: 'YouTube stream key',
            bitrateKbps: 'Bitrate (kbps)',
            save: 'Save',
            saved: 'Saved.',
            saveFailed: 'Save failed.',
            resetStream: 'Reset stream',
            resetStreamConfirm: 'Reset the YouTube liveStream for this table? A new stream will be created on next start.',
            resetStreamDone: 'Stream reset. A new liveStream will be created on next start.',
            resetStreamFailed: 'Reset failed.',
            sponsorsTitle: 'Sponsors',
            sponsorName: 'Name',
            sponsorType: 'Type',
            sponsorFilePath: 'Image path on server',
            sponsorPosX: 'X',
            sponsorPosY: 'Y',
            sponsorWidth: 'W',
            sponsorHeight: 'H',
            sponsorOrder: 'Order',
            addSponsor: 'Add sponsor',
            deleteSponsor: 'Delete',
            previewLogo: 'Preview',
            logoNotFound: 'Logo file not found on server.',
            sponsorAdded: 'Sponsor added.',
            sponsorUpdated: 'Sponsor updated.',
            sponsorDeleted: 'Sponsor deleted.',
            editSponsor: 'Edit Sponsor',
            saveChanges: 'Save changes',
            cancelEdit: 'Cancel',
            previewScene: 'Preview Scene',
            exportSponsors: 'Export sponsors (.json)',
            importSponsors: 'Import sponsors (.json)',
            sponsorsExported: 'Sponsors exported.',
            sponsorsImported: 'Sponsors imported — existing sponsors were replaced.',
            sponsorsImportFailed: 'Import failed — check the file is valid sponsor JSON.',
            sponsorTypes: {
                CLUB: 'Club logo',
                MAJOR: 'Major sponsor',
                MINOR: 'Minor sponsor',
            },
            reAuthWarning: 'YouTube Live requires re-authorization (new scope: youtube.force-ssl). Please reconnect your YouTube account in the YouTube Upload section.',
        },
    },
    serviceScore: {
        noStream: 'No active stream.',
        noStreamHint: 'Ask the admin to start streaming.',
        matchScore: 'MATCH SCORE',
        gameScore: 'GAME SCORE',
        tableLabel: 'Table',
        serviceTable: 'Service table',
        serviceTableRequired: 'Required for Service accounts',
        newPassword: 'New password',
        newPasswordPlaceholder: 'Leave empty to keep current password',
        newPasswordHint: 'Default password is "password". Change it here.',
        confirmLogout: 'Log out of this scoreboard device?',
        extended: {
            toggleOn: 'Switch to extended scoreboard (shot clock)',
            toggleOff: 'Back to the standard scoreboard',
            reset: 'RESET',
            extend: '+30s',
            switchPlayer: 'SWITCH',
            start: 'START',
            pause: 'PAUSE',
            resume: 'RESUME',
            sound: 'Sound',
            soundOff: 'Muted',
            expired: 'TIME',
            timeout: 'TIMEOUT',
            timeoutEnd: 'END TIMEOUT',
            matchTime: 'MATCH TIME LEFT',
            keepAwakeHint: 'Tip: turn off auto-lock on this device so the screen stays on.',
            extAvailable: '+30s still available',
        },
    },
} as const
